import { useState } from "react";
import { getSales } from "../services";

/**
 * Formatea los datos de las ventas (opcional)
 * @param {Array} data
 * @returns {Array}
 */
const formatData = (data) => {
  const color = ['#0767A2', '#B96800', '#409FD9', '#EE8D11', "", "#77AF6E", "#77D860"]
  return data.map((row) => ({
    color: color[row.serviceprops?.id - 1],
    ano: new Date(row.saleDate).getFullYear(),
    servicio: row.serviceprops?.nombre,
    nif: row.properties?.nif,
    nif_aaff: row.aaff?.nif,
    finca: row.properties,
    comunidad: row.workcenters?.razonSocial || row.properties?.razonSocial,
    codigoPostal: row.properties.codigoPostal,
    saleDate: row.saleDate,
    fechaEnvio: row.adviceDate,
    all_row: row,
    noVisita: typeof row.detailsCae?.[0] !== 'undefined' && row.detailsCae[0]?.unRealized,
    fechaRealizada: row.servp_id === 2 || row.servp_id === 4 ? row.adviceDate : !row.detailsCae?.[0]?.unRealized && row.detailsCae?.[0]?.visitSheet?.createdAt !== null && row.detailsCae?.[0]?.visitSheet?.createdAt !== undefined ? row.detailsCae[0]?.visitSheet?.createdAt : '',
    editar: row,
    details_lopd: row.detailsLopd?.length,
    details_cae: row.detailsCae?.[0]?.visitada === undefined ? null : row.detailsCae[0].visitada,
    unRealized: row.detailsCae?.[0]?.unRealized,
    tecnico: row?.technicians ? row?.technicians?.nombre + " " + row?.technicians?.apellidos : "",
    isWorkcenter: row.workcenters ? true : false

  }));
};

/**
 * Custom Hook para obtener las ventas
 * @returns {any}
 */
const useVentas = () => {
  const [limite, setLimite] = useState(0);
  
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    meta:{},
    rows: []
  });

  const fetchData = async ({ offset, limit, filtros, orderBy, order }) => {
    setLimite(limit);
    // console.log({ offset, limit, filtros, orderBy, order });
  
    let payload;
    if (orderBy && order) {
      payload = {
        params: { page: parseInt(offset), limit: parseInt(limit), order, orderBy },
        filtros
      };
    } else {
      payload = {
        params: { page: parseInt(offset), limit: parseInt(limit) },
        filtros
      };
    }
    try {
      let response = await getSales(payload);   
      if (!response || !response.data) {
        throw new Error("La respuesta no contiene datos");
      }

      const { meta, data } = response;

      setData({
        meta,
        rows: formatData(data || []), // Evita errores si `data` es undefined
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchData,
    formatData,
    data,
    loading
  };
};

export default useVentas;
